import type { BetterstartPresetId } from '@cli-types/preset-engine/presets.js'
import { presetTemplates } from './preset-templates.js'

export function readPresetTemplate(presetId: BetterstartPresetId, relativePath: string): string {
  return presetTemplates.read(presetId, relativePath)
}
